<template>
  <div>
    <PromptControl
      @ok="promptOk"
      @cancel="promptCancel"
      @closed="promptClosed"
      v-bind:show="cancel_prompt.display"
      v-bind:title="lang('lbl_0000515')"
      v-bind:message="lang('lbl_0000514')"
    />

    <ContentWrapperControl>
      <div class="bg-white rounded-b-lg shadow overflow-hidden p-4 mb-4">
        <div
          v-text="lang('lbl_0000046')"
          class="text-sm leading-normal text-grey-darkest"
        ></div>
      </div>

      <div class="bg-white rounded-lg shadow overflow-hidden">
        <OTPControl
          @success="success"
          @failed="failed"
          @showloader="showloader"
          @hideloader="hideloader"
          v-bind:type="type"
          v-bind:pin="pin"
          v-bind:mobile="mobile_no"
          v-bind:email="email"
          v-bind:name="name"
        />
      </div>
    </ContentWrapperControl>
  </div>
</template>

<script>
import ContentWrapperControl from "./../../components/controls/ContentWrapperControl.vue";
import OTPControl from "./../../components/controls/OTPControl.vue";
import PromptControl from "./../../components/controls/PromptControl.vue";
import mixin from "./../../mixin.js";

export default {
  mixins: [mixin],

  components: {
    ContentWrapperControl,
    OTPControl,
    PromptControl,
  },

  data() {
    return {
      type: 1,
      pin: null,
      name: null,
      email: null,
      mobile_no: null,
      allowNavigation: false,

      cancel_prompt: {
        display: false,
      },
    };
  },

  beforeRouteLeave(to, from, next) {
    if (this.allowNavigation) {
      next();
      return;
    }

    this.cancel_prompt.display = true;

    next(false);
  },

  mounted() {
    this.$emit("checkauth", false);

    this.$emit("shownavbar", {
      title: this.lang("lbl_0000013"),
      show: true,
      back: true,
    });

    let state = this.$store.state.forgot;

    if (state.hash == null || state.pin == null) {
      this.allowNavigation = true;
      this.$router.push("/forgot-password");
      return;
    }

    this.pin = state.otp.pin;
    this.mobile_no = state.mobile;
    this.email = state.email;
    this.name = state.first_name;
  },

  methods: {
    success(data) {
      this.$store.state.forgot.otp.token = data.otp_token;

      this.allowNavigation = true;

      this.$router.push("/forgot-password/update");
    },

    failed(message) {
      this.$emit("alert", {
        theme: "error",
        title: this.lang("lbl_0000034"),
        message: message,
      });
    },

    showloader() {
      this.$emit("showloader");
    },

    hideloader() {
      this.$emit("hideloader");
    },

    promptOk() {
      let state = this.$store.state.forgot;

      state.value = null;
      state.uuid = null;
      state.hash = null;
      state.pin = null;
      state.email = null;
      state.mobile = null;
      state.otp.pin = null;
      state.otp.token = null;

      this.allowNavigation = true;
      this.cancel_prompt.display = false;

      this.$router.push("/");
    },

    promptCancel() {
      this.cancel_prompt.display = false;
    },

    promptClosed() {
      this.cancel_prompt.display = false;
    },
  },
};
</script>
